<script setup lang="ts">
import {useEnums, useOrderViewContext} from '@hantera/portal-app';
import Actions from './Actions.vue';
import {DataColumnValuesEnumValue, EnumsBar} from "@hantera/design-system";
import {computed} from "vue";

const orderViewContext = useOrderViewContext();
const enums = useEnums()

async function addTag(value: DataColumnValuesEnumValue) {
  await orderViewContext.pushPendingChange(
    undefined,
    [{
      type: 'addTag',
      key: value.key,
    }],
    'Added tag {label}',
    {
      label: value.label,
      tagKey: value.key,
    }
  );
}

async function removeTag(value: DataColumnValuesEnumValue) {
  await orderViewContext.pushPendingChange(
    undefined,
    [{
      type: 'removeTag',
      key: value.key,
    }],
    'Removed tag {label}',
    {
      label: value.label,
      tagKey: value.key,
    }
  );
}

const availableTags = computed(() => {
  return enums.valueSets('order', 'tags').value;
})

</script>

<template>
  <div class="order__header">
    <div class="tags">
      <EnumsBar
        :available-sets="availableTags"
        :selected-values="orderViewContext.state.tags"
        :tags="orderViewContext.state.tags"
        @add="addTag"
        @remove="removeTag"
      >
<!--        <template #dropdown>-->
<!--          <DropdownItem @click="() => enums.openEditor('order', 'tags')">-->
<!--            Configure Tags-->
<!--          </DropdownItem>-->
<!--        </template>-->
      </EnumsBar>
    </div>
    <div class="actions">
      <Actions />
    </div>
  </div>
</template>

<style scoped>
.order__header {
  display: flex;
  flex-grow: 1;
  gap: 5px;
  flex-wrap: wrap;
}

.actions {
  display: flex;
  gap: 5px;
  justify-content: end;
}

.tags {
  flex-grow: 1;
}
</style>